import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/forms/terms.css';
import { AppContext } from '../../Store';
import { Trans } from 'react-i18next';

function Terms({
	onChangeCallback = null,
	showCheckbox = false,
	termsLinkId = 'n/a',
	privacyLinkId = 'n/a',
	extraStyle = '',
}) {
	const state = useContext(AppContext)[0];

	return (
		<div className={`${styles.terms} ${styles[extraStyle]}`}>
			{showCheckbox && (
				<input
					data-testid="checkbox"
					className={styles.input}
					type="checkbox"
					onChange={onChangeCallback}
					id='terms-input'
				></input>
			)}
			<label
				className={styles.termsText}
				htmlFor='terms-input'
			>
				<span className={styles.termsSpan}>
					<Trans i18nKey='translation:form.terms.label'>
						I accept the&nbsp;
						<a
							className={styles.link}
							href={state.termsAndConditionsUrl}
							target="_blank"
							rel="noreferrer"
							id={termsLinkId}
						>
							Terms and Conditions
						</a>.
					</Trans>
					<br/>
					<Trans i18nKey='translation:form.privacyPolicy'>
						You can find our Privacy Policy&nbsp;
						<a
							className={styles.link}
							href={state.privacyUrl}
							target="_blank"
							rel="noreferrer"
							id={privacyLinkId}
						>
							here
						</a>.
					</Trans>
				</span>
			</label>
		</div>
	);
}

export default Terms;

Terms.propTypes = {
	onChangeCallback: PropTypes.func,
	showCheckbox: PropTypes.bool,
	termsLinkId: PropTypes.string,
	privacyLinkId: PropTypes.string,
	extraStyle: PropTypes.string,
};
